import logo from './logo.svg';

import './css/style.css'
import './css/icofont.min.css'
import ModeSwitcher from './ModeSwitcher';
import { ThemeProvider } from './ThemeContext';
import Home from './Pages/Home';
import ScrollToTop from './ScrollToTop';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

function App() {
  return (
    <div className="App">

<ThemeProvider>
        <ModeSwitcher/>

      <Router>
      <ScrollToTop />
        <Routes>

          {/* Frontend Page */}
          <Route path="/" element={<Home/>} />
        







        </Routes>
      </Router>
      </ThemeProvider>



     
    </div>
  );
}

export default App;
